@for (row of rows(); track row.channel) {
  <section class="send" [class.complete]="row.complete" [class.has-failures]="row.failed.length > 0">
    <header>
      <h3>{{ row.title }}</h3>
      <button
        aria-label="Dismiss"
        class="close"
        inlineSVG="/assets/icons/close.svg"
        type="button"
        (click)="dismiss(row.channel)"
      ></button>
    </header>

    <p class="fund-name">{{ row.fundName }}</p>

    <mat-progress-bar mode="determinate" [value]="row.percent"></mat-progress-bar>

    @if (row.hadIssues) {
      <ul class="traffic-lights" aria-label="Delivery status">
        <li class="sent"><span class="label"><span class="count">{{ row.sentCount }}</span> sent</span></li>
        <li class="retrying"><span class="label"><span class="count">{{ row.retryingCount }}</span> retrying</span></li>
        <li class="failed"><span class="label"><span class="count">{{ row.failedCount }}</span> failed</span></li>
      </ul>
    }

    @if (row.failed.length > 0) {
      <details class="failures">
        <summary>Failed emails</summary>
        <div class="list">
          <ul>
            @for (recipient of row.failed; track recipient.email_personalization_id) {
              <li>{{ recipient.email }}</li>
            }
          </ul>
          <button
            aria-label="Copy failed emails to clipboard"
            class="copy"
            inlineSVG="/assets/icons/copy.svg"
            title="Copy failed emails"
            type="button"
            (click)="copyFailedEmails(row)"
          ></button>
        </div>
      </details>
    }
  </section>
}
